$(document).ready(function() {
  let $navMobile = $('#nav-mobile');

  //dropdown hover  
  $('#nav>ul>li').hover(function() {
    $(this).children('a').attr('aria-expanded', 'true');
    $(this).children('ul').stop(true, false, true).fadeIn(300);
  }, function() {
    $(this).children('a').attr('aria-expanded', 'false');
    $(this).children('ul').stop(true, false, true).fadeOut(300);
  });

  // #menu-mobile
  $('#menu-mobile').on('click', function(event) {
    event.preventDefault();

    $(this).toggleClass('open');
    $navMobile.find('.menu-xs').removeClass('open');
  });

  $('#btn-close, main').on('click', function(event) {
    $navMobile.find('.nav-container').slideUp();
    $('#menu-mobile').removeClass('open');
    $navMobile.find('.menu-xs').removeClass('open');
  });

  //nav-mobile
  const navbarToggle = function() {
    $('#navbar-btn').on('click', function(event) {
      event.preventDefault();

      $(this).blur();

      if ($(window).width() < 768) {
        let $menuMobile = $('#nav-mobile'),
          $menuMobileUl = $menuMobile.find('ul'),
          $menu = $('#nav .menu>li');

        $menuMobileUl.empty();
        $menu.find('ul').css('height', '');
        $menu.clone().appendTo($menuMobileUl);
        $menuMobileUl.find('.sub-menu').hide();
        $menuMobile.find('.nav-container').slideToggle();
      } else {
        $('#header .menu-wrapper').slideToggle();
      }
    });

    $navMobile.on('click', 'a', function(event) {
      event.stopPropagation();

      if ($(this).next('.sub-menu').length) {
        event.preventDefault();

        const $this = $(this),
          $menuItems = $('.menu-xs>li').not($(this).parent());

        if (!$(this).parent().parent().hasClass('submenu-has-children')) {
          $navMobile.find('.open').removeClass('open');
          $navMobile.find('.sub-menu').slideUp(300);

          if ($menuItems.is(':visible')) {
            $menuItems.slideUp('open');
          } else {
            $menuItems.slideDown('open');
          }
        }

        $this.next('.sub-menu').css('height', '').stop(true, false, true).slideToggle(300, function () {
          if ($(this).is(':hidden')) {
            $this.removeClass('open');
            $this.parent().removeClass('open');
          } else {
            $this.addClass('open');
            $this.parent().addClass('open');
          }
        });
      }           
    });

    $navMobile.on('click', '.submenu-name', function() {
      if ($(window).width() < 768) {
        const $this = $(this);

        $this.parent().parent().find('.submenu-list').slideUp(300);
        $this.next('.submenu-list').stop(true, false, true).slideToggle(300);
      }
    });
  };
  navbarToggle();
});


// WEBPACK FOOTER //
// ./src/js/components/navbar.js